import React from 'react';
import PropTypes from 'prop-types';
import BaseDropdownV2 from '../BaseDropdownV2';
import { search } from 'services/skill-matric-services/smSkillLevelService';

const SmSkillLevelDropdown = ({
  param,
  handleChange,
  selectedOptions,
  isDisabled = false,
  maxDisplayLevel = 2
}) => {
  console.log(maxDisplayLevel)
  return (
    <>
      <BaseDropdownV2
        key={`dropdown-${maxDisplayLevel}`}
        disabled={isDisabled}
        fieldName="skillLevelId"
        title="Skill Level"
        closeMenuOnSelect={true}
        isMulti={false}
        placeholder="Skill Level"
        handleChange={handleChange}
        getSource={search}
        sourceParam={param}
        mapToOption={res => {
          return res?.items
            .filter(i => i.levelNo <= maxDisplayLevel)
            .map(i => ({
              ...i,
              value: i.id,
              label: i.levelNo + ' - ' + i.name
            }));
        }}
        value={selectedOptions}
      />
    </>
  );
};

SmSkillLevelDropdown.propTypes = {
  collapseValues: PropTypes.bool,
  maxToShow: PropTypes.number,
  param: PropTypes.object,
  handleChange: PropTypes.func,
  selectedOptions: PropTypes.object,
  isDisabled: PropTypes.bool,
  maxDisplayLevel: PropTypes.number
};

export default SmSkillLevelDropdown;
